import { domainsConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  response: null,
  error: null
};

export const domains = (state = initialState, action) => {
  switch (action.type) {
    case domainsConstants.GET_DOMAINS_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case domainsConstants.GET_DOMAINS_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case domainsConstants.GET_DOMAINS_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.error
      };
    case domainsConstants.GET_DOMAINS_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
